import { Routes } from '@angular/router';
import { ArabActuariesLeagueComponent } from './technical-committee/arab-actuaries-league/arab-actuaries-league.component';
import { ArabInsuranceRegulationsLeagueComponent } from './technical-committee/arab-insurance-regulations-league/arab-insurance-regulations-league.component';
import { ArabInsuranceBrokersLeagueComponent } from './technical-committee/arab-insurance-brokers-league/arab-insurance-brokers-league.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'display-pdf/:pdfURL',
    loadComponent: () =>
      import('./core/components/display-pdf/display-pdf.component').then(
        (m) => m.DisplayPdfComponent
      ),
  },
  {
    path: 'display-pdf/:pdfURL/:showPDF',
    loadComponent: () =>
      import('./core/components/display-pdf/display-pdf.component').then(
        (m) => m.DisplayPdfComponent
      ),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./home-page/home-page.component').then(
        (m) => m.HomePageComponent
      ),
  },
  {
    path: 'magazines',
    loadComponent: () =>
      import('./magazines/magazines-list/magazines-list.component').then(
        (m) => m.MagazinesListComponent
      ),
  },
  {
    path: 'milestones',
    loadComponent: () =>
      import('./milestones/milestone/milestone.component').then(
        (m) => m.MilestoneComponent
      ),
  },

  {
    path: 'arab-actuaries-league',
    loadComponent: () =>
      import(
        './technical-committee/arab-actuaries-league/arab-actuaries-league.component'
      ).then((m) => ArabActuariesLeagueComponent),
  },
  {
    path: 'arab-insurance-regulations-league',
    loadComponent: () =>
      import(
        './technical-committee/arab-insurance-regulations-league/arab-insurance-regulations-league.component'
      ).then((m) => ArabInsuranceRegulationsLeagueComponent),
  },
  {
    path: 'arab-insurance-brokers-league',
    loadComponent: () =>
      import(
        './technical-committee/arab-insurance-brokers-league/arab-insurance-brokers-league.component'
      ).then((m) => ArabInsuranceBrokersLeagueComponent),
  },

  {
    path: 'news-letter/:newsType',
    loadComponent: () =>
      import('./news-letter/news-press-list/news-press-list.component').then(
        (m) => m.NewsPressListComponent
      ),
  },
  {
    path: 'news-press/:newsType',
    loadComponent: () =>
      import('./news-letter/news-press-list/news-press-list.component').then(
        (m) => m.NewsPressListComponent
      ),
  },
  {
    path: 'news/:newsType',
    loadComponent: () =>
      import('./news-letter/news-press-list/news-press-list.component').then(
        (m) => m.NewsPressListComponent
      ),
  },
  {
    path: 'members',
    loadComponent: () =>
      import('./members/members-list/members-list.component').then(
        (m) => m.MembersListComponent
      ),
  },
  {
    path: 'members/:id',
    loadComponent: () =>
      import('./members/member-details/member-details.component').then(
        (m) => m.MemberDetailsComponent
      ),
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./about/about.component').then((m) => m.AboutComponent),
  },
  {
    path: 'federation-membership',
    loadComponent: () =>
      import('./about/about-membership/about-membership.component').then(
        (m) => m.AboutMembershipComponent
      ),
  },
  {
    path: 'contact-us',
    loadComponent: () =>
      import('./contact-us/contact-us.component').then(
        (m) => m.ContactUsComponent
      ),
  },
  {
    path: 'arab-insurance-institute',
    loadComponent: () =>
      import(
        './arab-insurance-institute-page/arab-insurance-institute-page.component'
      ).then((m) => m.ArabInsuranceInstitutePageComponent),
  },
  {
    path: 'seminars',
    loadComponent: () =>
      import('./seminars/seminar/seminar.component').then(
        (m) => m.SeminarComponent
      ),
  },
  {
    path: 'events',
    loadComponent: () =>
      import('./events/events-list/events-list.component').then(
        (m) => m.EventsListComponent
      ),
  },
  {
    path: 'event/:event',
    loadComponent: () =>
      import('./events/event-details/event-details.component').then(
        (x) => x.EventDetailsComponent
      ),
  },
  {
    path: 'general-secretariat',
    loadComponent: () =>
      import('./general-secretariat/general-secretariat.component').then(
        (m) => m.GeneralSecretariatComponent
      ),
  },
  {
    path: 'executive-committee',
    loadComponent: () =>
      import('./executive-committee/executive-committee.component').then(
        (m) => m.ExecutiveCommitteeComponent
      ),
  },
  {
    path: 'committees-leagues',
    loadComponent: () =>
      import('./committees-leagues/committees-leagues.component').then(
        (m) => m.CommitteesLeaguesComponent
      ),
  },
  {
    path: 'insurance-library',
    loadComponent: () =>
      import(
        './insurance-library/insurance-library/insurance-library.component'
      ).then((m) => m.InsuranceLibraryComponent),
  },
  {
    path: 'council-board',
    loadComponent: () =>
      import('./council/council/council.component').then(
        (m) => m.CouncilComponent
      ),
  },
  {
    path: 'general-conferences',
    loadComponent: () =>
      import(
        './general-conference/general-conference/general-conference.component'
      ).then((m) => m.GeneralConferenceComponent),
  },
  {
    path: 'directory/:id',
    loadComponent: () =>
      import('./directory/directory-details/directory-details.component').then(
        (m) => m.DirectoryDetailsComponent
      ),
  },
  {
    path: 'sign-up',
    loadComponent: () =>
      import('./users/sign-up/sign-up.component').then(
        (m) => m.SignUpComponent
      ),
  },
  {
    path: 'sign-up/:directoryId',
    loadComponent: () =>
      import('./users/sign-up/sign-up.component').then(
        (m) => m.SignUpComponent
      ),
  },
  {
    path: 'subscribe/:directoryId',
    loadComponent: () =>
      import('./directory/subscribe/subscribe.component').then(
        (m) => m.SubscribeComponent
      ),
  },
  {
    path: 'careers',
    loadComponent: () =>
      import('./careers/careers.component').then((m) => m.CareersComponent),
  },
  {
    path: 'general-assembly',
    loadComponent: () =>
      import('./general-assembly/general-assembly.component').then(
        (m) => m.GeneralAssemblyComponent
      ),
  },
];
